module.exports = "<p ng-class=\"{'form-control-static': true, 'with-linebreaks': $ctrl.multiline, 'not-translated': !$ctrl.isTranslated()}\">{{ $ctrl.getValue() }}</p> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/i18n/p_partial.html
// module id = 545
// module chunks = 0